import { render, staticRenderFns } from "./users.vue?vue&type=template&id=44c4c24e&ref=childRef2"
import script from "./users.vue?vue&type=script&lang=js"
export * from "./users.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44c4c24e')) {
      api.createRecord('44c4c24e', component.options)
    } else {
      api.reload('44c4c24e', component.options)
    }
    module.hot.accept("./users.vue?vue&type=template&id=44c4c24e&ref=childRef2", function () {
      api.rerender('44c4c24e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/settings/users.vue"
export default component.exports